export const EMAIL_BODY = 'Thank you for contacting support. %0A %0A Please type your question below and include your' +
  'full name, your university or property, your phone number, and what platform you are using RoomSync on (iPhone, And' +
  'roid, iPad, laptop, etc). %0A %0A If this is urgent, please call us at 352.327.4061 ext. 2'
export const EMAIL_SUBJECT = 'RoomSync Support Request'

export const MAIN_NAV_ID = "main-navigation"
export const PAGE_CONTENT_ID = "page-content"
export const PAGE_TITLE_ID = "page-title"